/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { Tooltip, TextInput } from '../../../canvasComponents/index';
import { IntlProvider, injectIntl } from 'react-intl';
import settingsForm from './CustomAutocomplete.settingsForm';
import getLocalParams from '../localizationCustoms';

class CustomAutocomplete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      suggestions: [],
      filteredSuggestions: [],
      value: props.value === null ? '' : props.value,
    };
  }

  componentDidMount() {
    const { props: { component: { data, dataSrc } }, state: { value } } = this || null;

    let transformedSuggestions = [];
    if (data !== undefined
      && dataSrc !== undefined
      && dataSrc === 'values') {
      transformedSuggestions = data.values.map((suggestion) => ({
        value: suggestion,
        label: <span>{suggestion}</span>,
      }));

      this.setState({ value, suggestions: transformedSuggestions });
    } else if (data !== undefined
      && dataSrc !== undefined
      && dataSrc === 'custom'
      && data.custom !== undefined) {
      try {
        // eslint-disable-next-line no-eval
        const suggestionsArray = eval(data.custom);
        this.setState({
          value,
          suggestions: suggestionsArray,
        });
      } catch (e) {
        if (e instanceof SyntaxError) {
          this.setState({ value, suggestions: [] });
        }
      }
    }
  }

  onChangeAutocomplete = (currentValue) => {
    const { state: { suggestions }, props: { onChange } } = this;

    // Filter our suggestions that don't contain the user's input
    const filteredSuggestions = suggestions.filter(
      (suggestion) => suggestion.value.toLowerCase().indexOf(currentValue.toLowerCase()) === 0,
    );

    this.setState(
      {
        filteredSuggestions,
        value: currentValue,
      },
      () => {
        let checkIfExists = false;
        suggestions.forEach((suggestion) => {
          if (suggestion.value.toLowerCase() === currentValue.toLowerCase()) {
            checkIfExists = true;
          }
        });
        // eslint-disable-next-line react/destructuring-assignment
        onChange(checkIfExists ? this.state.value : '');
      },
    );
  };

  onClick = (selectedValue) => {
    const { onChange } = this.props || null;
    this.setState(
      {
        value: selectedValue,
      },
      () => {
        // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      },
    );
  };

  render() {
    const { onChangeAutocomplete, onClick, state: { value, filteredSuggestions }, props: { disabled, component: { hideCustomLabel, tooltip, label, placeholder }, intl } } = this;

    return (
      <>
        {!hideCustomLabel && (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <label className="label-question">
            {label}
          </label>
          {tooltip !== '' && (
            <Tooltip id="textfield_tooltip" primary>
              {tooltip}
            </Tooltip>
          )}
        </div>
        )}
        <TextInput
          searchable
          searchResults={filteredSuggestions}
          emptySearchResultsMessage="No results"
          minLengthForSearchResults={1}
          disabled={disabled}
          placeholder={placeholder ? intl.formatMessage({ id: `${placeholder}`, defaultValue: `${placeholder}` }) : ''}
          highlight
          primary
          onSelect={(selectedValue) => onClick(selectedValue)}
          onChange={(currentValue) => onChangeAutocomplete(currentValue)}
          value={value && value.value ? value.value : ''}
        />
      </>
    );
  }
}

const CustomAutocompleteWithIntl = injectIntl(CustomAutocomplete);

export default class AutocompleteComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom Autocomplete',
      icon: 'terminal',
      group: 'basic',
      documentation: '',
      schema: AutocompleteComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customautocomplete',
        hideLabel: false,
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = settingsForm;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  attachReact(element) {
    const localParams = getLocalParams(this.i18next.language);
    let instance;
    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomAutocompleteWithIntl
          inputRef={(refer) => {
            instance = refer;
          }}
          disabled={this._disabled}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          onChange={this.updateValue} // The onChange event to call when the value changes.
        />
      </IntlProvider>,
      element,
      // eslint-disable-next-line no-return-assign
      () => (this.reactInstance = instance),
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  // eslint-disable-next-line class-methods-use-this
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
